<template>
  <div class="column" :class="columnSize">
    <div class="card height-100">
      <header class="header-card">
        <p>
          {{ $t('detailCatalogue.comptabilite.title') }}
        </p>
      </header>
      <div class="card-content">
        <div class="columns">
          <div class="column is-4">
            <detail-compte-analytique :produit="produit"></detail-compte-analytique>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import detailCompteAnalytique from '@/components/catalogue/produitGeneral/compteAnalytique/detailCompteAnalytique';

export default {
  props: {
    produit: {
      type: Object,
      required: true,
    },
    columnSize: {
      type: String,
      required: false,
      default: 'is-12',
    },
  },
  components: {
    detailCompteAnalytique,
  },
};
</script>
